import { useParams } from 'react-router-dom';
import { TabBar } from 'shared-components';
import { useFormikContext } from 'formik';
import { useGetCouponQuery } from './coupons.api';
import { CouponAction, ICoupon } from '@topshots/core-models';
import {
  FormGroup,
  Card,
  Select,
  CardContent,
  Input,
  FormLayout,
  Label,
  Checkbox,
} from 'shared-components';

export const CouponForm = () => {
  // const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const { data, isLoading, isFetching } = useGetCouponQuery(id as string);
  // const [deleteCoupon, { isLoading: deleteCouponLoading }] =
  //   useDeleteCouponMutation();
  const { getFieldProps, handleSubmit, errors, values } =
    useFormikContext<ICoupon>();
  if (isLoading || isFetching) {
    return <span>loading...</span>;
  }

  if (!data) return <span>Coupon not found</span>;

  return (
    <>
      {/* <ActionsBar
        onAction={async (action) => {
          switch (action) {
            case 'save':
              submitForm();
              break;
            case 'delete':
              // eslint-disable-next-line no-restricted-globals
              if (confirm('Are you sure you want to delete this coupon?')) {
                await deleteCoupon(id as string);
                navigate(RouteList.COUPONS.link);
                toast.success('Coupon deleted!');
              }
              break;
          }
        }}
      /> */}
      <Card>
        <CardContent>
          <TabBar tabs={[{ display: 'Details', link: '', endMatch: true }]} />
          <form onSubmit={handleSubmit}>
            <FormLayout>
              <FormGroup>
                <Checkbox
                  label="Is active?"
                  type="checkbox"
                  id="isActive"
                  defaultChecked={data?.isActive}
                  {...getFieldProps('isActive')}
                />
                {/* <input
                  type="checkbox"
                  id="isActive"
                  defaultChecked={data?.isActive}
                  {...getFieldProps('isActive')}
                />
                <label htmlFor="isActive">Is active?</label> */}
              </FormGroup>
              <FormGroup>
                <Label htmlFor="code">Code</Label>
                <Input {...getFieldProps('code')} type="text" id="code" />
                {errors.code && <span>{errors.code}</span>}
              </FormGroup>
              <FormGroup>
                <Label htmlFor="action">Action</Label>
                <Select {...getFieldProps('action')} id="action">
                  <option value={CouponAction.FixedDiscount}>
                    Fixed Discount
                  </option>
                  <option value={CouponAction.FreeShipping}>
                    Free Shipping
                  </option>
                  <option value={CouponAction.PercentageDiscount}>
                    Percentage Discount
                  </option>
                </Select>
                {errors.action && <span>{errors.action}</span>}
              </FormGroup>
              {values.action !== CouponAction.FreeShipping && (
                <FormGroup>
                  <Label htmlFor="value">
                    Discount{' '}
                    {values.action === CouponAction.FixedDiscount
                      ? '(£)'
                      : '(%)'}
                  </Label>
                  <Input {...getFieldProps('value')} type="number" id="value" />
                  {errors.value && <span>{errors.value}</span>}
                </FormGroup>
              )}
              <FormGroup>
                <Checkbox
                  label="Is limited?"
                  type="checkbox"
                  id="isLimited"
                  defaultChecked={data?.isLimited}
                  {...getFieldProps('isLimited')}
                />
                {/* <input
                  type="checkbox"
                  id="isLimited"
                  defaultChecked={data?.isLimited}
                  {...getFieldProps('isLimited')}
                />
                <label htmlFor="isLimited">Is limited?</label> */}
              </FormGroup>
              {values.isLimited && (
                <FormGroup>
                  <Label htmlFor="usageCap">Usage Cap</Label>
                  <Input
                    {...getFieldProps('usageCap')}
                    type="number"
                    id="usageCap"
                  />
                  {errors.usageCap && <span>{errors.usageCap}</span>}
                </FormGroup>
              )}
              <FormGroup>
                <Label htmlFor="usageCount">Usage Count</Label>
                <Input
                  {...getFieldProps('usageCount')}
                  type="number"
                  id="usageCount"
                />
                {errors.usageCount && <span>{errors.usageCount}</span>}
              </FormGroup>
              <FormGroup>
                <Label htmlFor="expiresAt">Expires</Label>
                <Input
                  {...getFieldProps('expiresAt')}
                  type="date"
                  id="expiresAt"
                />
              </FormGroup>
            </FormLayout>
          </form>
        </CardContent>
      </Card>
    </>
  );
};
